import type { ColorPalette } from 'config/theme/types';

export const zdfStreamingPortalColors: Partial<ColorPalette> = {
    // Text
    colorTextPrimary: '#FBFAFA',
    colorTextSecondaryOnBanner: '#DADFE5',
    colorTextSecondary: '#DADFE5',
    colorTextDisabled: '#82919C',
    colorTextHint: '#82919C',
    colorTextAccent: '#FFFFFF',
    colorTextWarning: '#FE9797',
    colorTextSuccess: '#76FC9A',
    colorTextOnPrimaryButton: '#0D1118',
    colorTextOnAccentColorBg: '#FFFFFF',
    colorTextOnEntryPointColorBg: '#FBFAFA',
    colorTextOnTagLight: '#0D1118',
    colorTextOnToastDark: '#0D1118',
    colorTextOnTeaserButton: '#0D1118',

    // Button
    colorButtonPrimary: '#FBFAFA',
    colorButtonAccent: '#FA7D19',
    colorButtonSecondary: '#2C363D',
    colorButtonDisabled: '#39434B',
    colorButtonSliderThumb: '#FBFAFA',
    colorButtonTeaser: '#FBFAFA',

    // Surface
    colorSurfacePrimary: '#131B22',
    colorSurfaceSecondary: '#1F2830',
    colorSurfaceHighlight: '#0D1118',
    colorSurfaceHighlightShade1: '#1F2830',
    colorSurfaceHighlightShade2: '#465058',
    colorSurfaceBannerWarning: '#1F2830',
    colorSurfaceBannerSuggestion: '#465058',
    colorSurfaceBannerSuccess: '#1F2830',
    colorSurfaceBannerInfo: '#1F2830',
    colorSurfaceUserBlock: '#FB4343',
    colorSurfaceUserWarning: '#FAE682',
    colorSurfaceUserUnblock: '#17BC45',
    colorSurfaceUserVerified: '#91A8BD',
    colorSurfacePopoverDark: '#FBFAFA',
    colorSurfaceToggleBackground: '#FFFFFF33',

    // Tag
    colorTagDefault: '#1F2830',
    colorTagAccent: '#FCB175',
    colorTagAccentLight: '#FFD8B9',
    colorTagHighlight: '#F9EBEC',
    colorTagWarning: '#FFC1C1',
    colorTagSuccess: '#76FC9A',
    colorTagVerified: '#CCDBE8',
    colorTagWhite: '#FBFAFA',

    // Border
    colorBorderPrimary: '#82919C',
    colorBorderPrimaryOnBanner: '#0d111833',
    colorBorderSelected: '#AEB6BC',
    colorBorderAccent: '#538CFF',
    colorBorderAccentLight: '#465058',
    colorBorderWarning: '#FE9797',
    colorBorderFace: '#39434B',

    // DataViz
    colorDataVizScale1: '#FA7D19',
    colorDataVizScale2: '#FCB175',
    colorDataVizScale3: '#543118',
    colorDataVizOther: '#39434B',
    colorDataVizCategory1: '#FA7D19',
    colorDataVizCategory2: '#B47AFF',
    colorDataVizCategory3: '#920000',
    colorDataVizCategory4: '#004A74',
    colorDataVizCategory5: '#538CFF',

    // Entry point colors
    colorEntryPointColorGreen: '#39434B',
    colorEntryPointColorGreenTint: '#1F2830',
};
